/* Skyteck shipping estimator — zone engine + PDP/cart widget controllers.
   Zone prices MUST mirror the live Bespoke Shipping config (changed there → change here).
   The cart widget upgrades the zone estimate with the LIVE checkout rate from
   /cart/shipping_rates.json (cart-scoped, so it is exact); the zone table remains the
   instant estimate + offline fallback. Checkout stays ground truth.
   2026-07-08 consignment model for the instant estimate (draft-order-probe verified):
   tag-bulky or unit≥25kg lines pool into ONE bulky consignment; a line whose unit is
   under 25kg but whose line total (unit×qty) crosses 25kg is its OWN consignment
   ("crossers", emitted by sections/skyteck-shipping-cart.liquid); light lines pool.
   Each consignment's kg rounds UP to a whole kg. Line-crosser behaviour is INTERIM
   pending the Bespoke support ticket (task #13) — if they scope the rule back to unit
   weight, drop the crosser handling here, in the cart section, and in PDP isBulky(). */
(function () {
  'use strict';
  if (window.__skShipInit) return;
  window.__skShipInit = true;

  /* Zone-aware delivery promise: metro runs 7 business days; regional NSW + WA 10;
     CQ mining runs are batched — 14. Lanes with no run cadence (NT, TAS, far-north
     QLD, remote SA…) get NO promise — '' beats promising Darwin a metro timeframe.
     Tune here if ops cadence changes. */
  function etaFor(pc) {
    if (inRange(pc, 4713, 4728) || inRange(pc, 4742, 4746) || pc === 4709) return ' — arrives within 14 business days';
    if (pc === 4570 || inRange(pc, 4600, 4699) || inRange(pc, 4810, 4825)) return ' — arrives within 14 business days';
    if (inRange(pc, 4307, 4413) || inRange(pc, 3231, 3699) || inRange(pc, 5175, 5375)) return ' — arrives within 10 business days';
    if (inRange(pc, 2331, 2897) || inRange(pc, 6000, 6999)) return ' — arrives within 10 business days';
    if (inRange(pc, 4000, 4306) || inRange(pc, 4350, 4352) || inRange(pc, 4500, 4521)) return ' — arrives within 7 business days';
    if (inRange(pc, 4550, 4575) || inRange(pc, 2000, 2330) || inRange(pc, 2500, 2530)) return ' — arrives within 7 business days';
    if (inRange(pc, 2555, 2574) || inRange(pc, 2740, 2770) || inRange(pc, 2900, 2920)) return ' — arrives within 7 business days';
    if (inRange(pc, 200, 299) || inRange(pc, 2600, 2618)) return ' — arrives within 7 business days';
    if (inRange(pc, 3000, 3230) || inRange(pc, 5000, 5174)) return ' — arrives within 7 business days';
    return '';
  }

  function inRange(pc, lo, hi) { return pc >= lo && pc <= hi; }

  /* Postcode → state for the live rates call. */
  function provinceFor(pc) {
    if (inRange(pc, 200, 299) || inRange(pc, 2600, 2618) || inRange(pc, 2900, 2920)) return 'Australian Capital Territory';
    if (inRange(pc, 1000, 2599) || inRange(pc, 2619, 2899) || inRange(pc, 2921, 2999)) return 'New South Wales';
    if (inRange(pc, 3000, 3999) || inRange(pc, 8000, 8999)) return 'Victoria';
    if (inRange(pc, 4000, 4999) || inRange(pc, 9000, 9999)) return 'Queensland';
    if (inRange(pc, 5000, 5999)) return 'South Australia';
    if (inRange(pc, 6000, 6999)) return 'Western Australia';
    if (inRange(pc, 7000, 7999)) return 'Tasmania';
    if (inRange(pc, 800, 999)) return 'Northern Territory';
    return '';
  }

  /* Returns {price, label} or {fallback:true}. One call = one consignment;
     kg rounds UP to a whole kg (checkout-verified); items = qty in the consignment. */
  function estimate(pc, grams, items, bulky) {
    if (!grams || grams <= 0) return { fallback: true };
    var kg = Math.ceil(grams / 1000);
    items = items || 1;
    if (inRange(pc, 4000, 4199) || inRange(pc, 4300, 4306)) return { price: 25 + (bulky ? 0.50 : 0.40) * kg, label: 'Brisbane metro & Ipswich' }; /* bulky 0.50 since 2026-07-09 */
    if (inRange(pc, 4200, 4299) || inRange(pc, 4500, 4521) || inRange(pc, 4550, 4569) || inRange(pc, 4571, 4575)) return { price: 39 + 0.50 * kg, label: 'Gold Coast & Sunshine Coast' };
    if (inRange(pc, 4350, 4352)) return { price: 59 + 0.50 * kg, label: 'Toowoomba' };
    if (inRange(pc, 4307, 4347)) return { price: (bulky ? 39 + 0.70 * kg : 29 + 0.50 * kg), label: 'Lockyer Valley' };
    if (inRange(pc, 4353, 4413)) return { price: (bulky ? 59 + 0.90 * kg : 45 + 0.60 * kg), label: 'Darling Downs' };
    if (pc === 4570 || inRange(pc, 4600, 4699)) return { price: (bulky ? 69 + 1.10 * kg : 49 + 0.70 * kg), label: 'Wide Bay' };
    if (inRange(pc, 4810, 4825)) return { price: (bulky ? 79 + 1.50 * kg : 59 + 1.00 * kg), label: 'Townsville' };
    if (inRange(pc, 4713, 4728)) { /* CQ Highlands (Blackwater/Emerald) — bulky-only zone */
      if (bulky) return { price: 80 + 0.50 * items + 1.85 * kg, label: 'Central QLD Highlands' };
      return { fallback: true };
    }
    if (inRange(pc, 4742, 4746) || pc === 4709) { /* Bowen Basin (Moranbah/Dysart/Tieri) — bulky-only zone */
      if (bulky) return { price: 115 + 0.50 * items + 2.60 * kg, label: 'Bowen Basin' };
      return { fallback: true };
    }
    if (inRange(pc, 2000, 2249)) return { price: ((17.25 + 0.65 * kg + 0.5 * items) * 1.2) + 1.20, label: 'Sydney metro' };
    if (inRange(pc, 2250, 2330) || inRange(pc, 2500, 2530)) return { price: 25 + 0.75 * kg, label: 'Newcastle, Central Coast & Illawarra' };
    if (inRange(pc, 2555, 2574) || inRange(pc, 2740, 2770)) return { price: 25 + 0.75 * kg, label: 'Sydney outer metro' };
    if (inRange(pc, 2331, 2897)) return { price: 45 + 1.40 * kg, label: 'Regional NSW & ACT' };
    if (inRange(pc, 3000, 3230)) return { price: 22 + 0.67 * kg, label: 'Melbourne & Geelong' };
    if (inRange(pc, 3231, 3699)) return { price: (bulky ? 39 + 1.00 * kg : 29 + 0.80 * kg), label: 'Regional VIC' };
    if (inRange(pc, 5000, 5174)) return { price: 37 + 0.70 * kg, label: 'Adelaide metro' };
    if (inRange(pc, 5175, 5375)) return { price: (bulky ? 49 + 1.00 * kg : 39 + 0.75 * kg), label: 'Adelaide Hills & Barossa' };
    /* WA: no instant estimate. The old hand-fitted Perth ($80 flat) and WA bulky
       formulas quoted prices checkout never charged — the only WA price we show is
       the live checkout rate, and fallback guarantees the phone lifeline for 6xxx. */
    if (inRange(pc, 6000, 6999)) return { fallback: true };
    return { fallback: true };
  }

  var fmt = new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' });
  function money(n) { return fmt.format(Math.round(n * 100) / 100).replace(/\.00$/, ''); }

  /* Regional-freight lifeline: on an uncovered/regional lane, or when freight is
     both a big share (>=40%) of goods AND >=$100 absolute (cheap metro never fires),
     offer a phone quote instead of losing the sale to sticker shock. */
  var FREIGHT_LIFELINE_RATIO = 0.40;
  var FREIGHT_LIFELINE_MIN = 100; /* dollars */
  function freightHigh(freightDollars, goodsCents) {
    return goodsCents > 0 && freightDollars >= FREIGHT_LIFELINE_MIN && (freightDollars * 100 / goodsCents) >= FREIGHT_LIFELINE_RATIO;
  }
  function appendLifeline(el) {
    var life = document.createElement('div');
    life.style.cssText = 'margin-top:6px;color:#b45309;font-weight:bold';
    life.textContent = "📞 That looks like a regional freight rate — call us on 1300 822 828 for the best delivery price (often cheaper than the online quote).";
    el.appendChild(life);
  }

  function savePc(pc) { try { localStorage.setItem('sk_postcode', pc); } catch (e) { /* private mode */ } }
  function loadPc() { try { return localStorage.getItem('sk_postcode') || ''; } catch (e) { return ''; } }

  /* Live checkout rates for the CURRENT cart. Exact — matches what checkout will show. */
  var liveCache = {};
  function liveRates(pcStr, cb) {
    if (liveCache[pcStr]) { cb(liveCache[pcStr]); return; }
    var pc = parseInt(pcStr, 10);
    var province = provinceFor(pc);
    var url = '/cart/shipping_rates.json?shipping_address[zip]=' + encodeURIComponent(pcStr)
      + '&shipping_address[country]=Australia'
      + (province ? '&shipping_address[province]=' + encodeURIComponent(province) : '');
    var attempt = 0;
    var RETRYING = {}; /* sentinel: another attempt is scheduled — don't resolve yet */
    function go() {
      attempt++;
      fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) {
          if (r.status === 202 && attempt < 3) { setTimeout(go, 1500); return RETRYING; }
          /* Non-OK (e.g. 422 for an invalid address) must still resolve the callback.
             Returning null here without calling cb used to strand the cart widget on
             its "Checking your exact delivery price…" spinner forever. */
          return r.ok ? r.json() : null;
        })
        .then(function (j) {
          if (j === RETRYING) return;
          var rates = (j && j.shipping_rates) || [];
          if (!rates.length) { cb(null); return; }
          var cheapest = rates.reduce(function (a, b) { return parseFloat(a.price) <= parseFloat(b.price) ? a : b; });
          var out = { price: parseFloat(cheapest.price), multiple: rates.length > 1 };
          liveCache[pcStr] = out;
          cb(out);
        })
        .catch(function () { cb(null); });
    }
    go();
  }

  /* ---------- PDP widget ---------- */
  function initPdp() {
    var dataEl = document.querySelector('[data-sk-ship-data]');
    if (!dataEl || dataEl.__skInit) return;
    dataEl.__skInit = true;
    var cfg;
    try { cfg = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var weights = cfg.weights || {};
    var variantId = String(cfg.selected || '');
    /* bulky = tagged OR the line total (unit×qty) crosses 25kg — mirrors Bespoke's
       _weight gte 25 rule as it actually evaluates at checkout (line weight; subsumes
       the unit≥25kg case at any qty). INTERIM per task #13. */
    function isBulky() { return !!cfg.bulky || (weights[variantId] || 0) * qty() >= 25000; }

    var root = dataEl.parentElement;
    var chipsEl = root.querySelector('[data-sk-chips]');
    var inputEl = root.querySelector('[data-sk-postcode]');
    var checkEl = root.querySelector('[data-sk-check]');
    var resultEl = root.querySelector('[data-sk-result]');

    /* Dawn's qty input sits OUTSIDE the product form (linked via form= attribute) */
    function qty() {
      var q = document.querySelector('.product-form__input input[name="quantity"], quantity-input input[name="quantity"], input[name="quantity"][form], form[action*="/cart/add"] input[name="quantity"]');
      var n = q ? parseInt(q.value, 10) : 1;
      return (n && n > 0) ? n : 1;
    }
    function grams() {
      var g = weights[variantId];
      return (g && g > 0) ? g * qty() : 0;
    }

    function renderChips() {
      var g = grams();
      if (!g) { chipsEl.textContent = ''; return; }
      var anchors = [['Brisbane', 4000], ['Sydney', 2000], ['Melbourne', 3000]];
      var parts = [];
      for (var i = 0; i < anchors.length; i++) {
        var est = estimate(anchors[i][1], g, qty(), isBulky());
        if (est && !est.fallback) parts.push(anchors[i][0] + ' ' + money(est.price));
      }
      chipsEl.textContent = parts.length ? 'e.g. ' + parts.join(' · ') : '';
    }

    function showResult(pcStr) {
      if (!pcStr) { resultEl.style.display = 'none'; return; }
      /* AU postcodes are exactly 4 digits (NT keeps its leading zero, e.g. 0870).
         Junk input used to fall through and even get saved to localStorage. */
      if (!/^\d{4}$/.test(pcStr)) {
        resultEl.style.display = 'block';
        resultEl.style.color = '#b91c1c';
        resultEl.textContent = 'Please enter your 4-digit postcode.';
        return;
      }
      var pc = parseInt(pcStr, 10);
      var est = estimate(pc, grams(), qty(), isBulky());
      resultEl.style.display = 'block';
      if (est.fallback) {
        resultEl.style.color = '#0e1b4d';
        resultEl.textContent = '🚚 We deliver to ' + pcStr + ' Australia-wide. Add to cart to see your exact freight — no surprises at checkout.';
      } else {
        resultEl.style.color = '#1a7f37';
        resultEl.textContent = '🚚 Delivery to ' + pcStr + ' (' + est.label + '): ' + money(est.price) + etaFor(pc);
      }
      var prices = cfg.prices || {};
      var goodsCents = (prices[variantId] || 0) * qty();
      if (est.fallback ? grams() > 0 : freightHigh(est.price, goodsCents)) appendLifeline(resultEl);
      savePc(pcStr);
    }
    function refresh() { renderChips(); if (inputEl.value.trim()) showResult(inputEl.value.trim()); }

    checkEl.addEventListener('click', function () { showResult(inputEl.value.trim()); });
    inputEl.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); showResult(inputEl.value.trim()); } });

    if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange) {
      window.subscribe(window.PUB_SUB_EVENTS.variantChange, function (event) {
        try {
          if (event && event.data && event.data.variant) { variantId = String(event.data.variant.id); refresh(); }
        } catch (e) { /* never break the PDP */ }
      });
    }
    /* qty +/- buttons and typed changes both bubble a change event to document */
    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'quantity') refresh();
    });
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('quantity-input button')) setTimeout(refresh, 50);
    });

    renderChips();
    var saved = loadPc();
    if (saved) { inputEl.value = saved; showResult(saved); }
  }

  /* ---------- Cart widget ---------- */
  function wireCart(root) {
    if (!root || root.__skInit) return;
    root.__skInit = true;
    var cfg;
    try { cfg = JSON.parse(root.querySelector('[data-sk-cart-ship]').textContent); } catch (e) { return; }
    var input = root.querySelector('[data-sk-cart-postcode]');
    var btn = root.querySelector('[data-sk-cart-check]');
    var out = root.querySelector('[data-sk-cart-result]');
    var seq = 0;

    function show(pcStr) {
      if (!pcStr) { out.style.display = 'none'; return; }
      if (!/^\d{4}$/.test(pcStr)) {
        out.style.display = 'block';
        out.style.color = '#b91c1c';
        out.textContent = 'Please enter your 4-digit postcode.';
        return;
      }
      var pc = parseInt(pcStr, 10);
      var mySeq = ++seq;
      var total = 0, fallback = false;
      function addConsignment(grams, items, bulky) {
        if (!(grams > 0)) return;
        var e = estimate(pc, grams, items, bulky);
        if (e.fallback) fallback = true; else total += e.price;
      }
      addConsignment(cfg.bulkyGrams, cfg.bulkyItems, true);
      /* each line-crosser (unit<25kg, line total ≥25kg) is its own consignment */
      var crossers = cfg.crossers || [];
      for (var i = 0; i < crossers.length; i++) addConsignment(crossers[i].g, crossers[i].q, true);
      addConsignment(cfg.lightGrams, cfg.lightItems, false);
      out.style.display = 'block';
      if (fallback || total <= 0) {
        out.style.color = '#0e1b4d';
        out.textContent = '🚚 Checking your exact delivery price for ' + pcStr + '…';
      } else {
        out.style.color = '#1a7f37';
        out.textContent = '🚚 Estimated delivery to ' + pcStr + ': ' + money(total);
      }
      savePc(pcStr);
      /* Upgrade to the LIVE checkout rate for this exact cart. */
      liveRates(pcStr, function (live) {
        if (mySeq !== seq) return; /* stale response — a newer check ran */
        if (live && live.price > 0) {
          out.style.color = '#1a7f37';
          out.textContent = '🚚 Delivery to ' + pcStr + ': ' + (live.multiple ? 'from ' : '') + money(live.price) + etaFor(pc) + ' (exact checkout price)';
          if (fallback || freightHigh(live.price, cfg.itemsSubtotal)) appendLifeline(out);
        } else if (fallback || total <= 0) {
          out.style.color = '#0e1b4d';
          out.textContent = '🚚 We deliver to ' + pcStr + ' — exact freight shown at checkout.';
          appendLifeline(out);
        }
      });
    }

    btn.addEventListener('click', function () { show(input.value.trim()); });
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); show(input.value.trim()); } });

    var saved = loadPc();
    if (saved) { input.value = saved; show(saved); }
    return { sectionId: cfg.sectionId };
  }

  var cartSectionId = null;
  function refreshCartSection() {
    if (!cartSectionId) return;
    fetch(window.location.pathname + '?sections=' + encodeURIComponent(cartSectionId))
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[cartSectionId];
        /* section id key can differ from Liquid's section.id in some setups — fall back to the first key */
        if (!html) { var keys = Object.keys(data || {}); if (keys.length === 1) html = data[keys[0]]; }
        if (!html) return;
        var current = document.querySelector('[data-sk-cart-root]');
        if (!current) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-sk-cart-root]');
        if (!fresh) return;
        /* Same consignment payload = same cart for our purposes. Skip the rewire —
           a rewire re-runs the saved-postcode live-rate lookup, which is what made
           one qty tap fire five section refetches plus five rate calls. Only a real
           change invalidates the rate cache. */
        var curCfg = current.querySelector('[data-sk-cart-ship]');
        var newCfg = fresh.querySelector('[data-sk-cart-ship]');
        if (curCfg && newCfg && curCfg.textContent === newCfg.textContent) return;
        liveCache = {}; /* cart contents changed — cached rates no longer valid */
        current.replaceWith(fresh);
        wireCart(fresh);
      }).catch(function () { /* keep old estimate */ });
  }
  /* Coalesced double-tap: rapid qty clicks reset the pair, so a burst ends in at most
     two section fetches (0.9s catches the normal case, 2.6s the slow one). */
  var cartRefreshTimers = [];
  function scheduleCartRefresh() {
    cartRefreshTimers.forEach(clearTimeout);
    cartRefreshTimers = [setTimeout(refreshCartSection, 900), setTimeout(refreshCartSection, 2600)];
  }

  function initCart() {
    var root = document.querySelector('[data-sk-cart-root]');
    if (!root) return;
    var info = wireCart(root);
    if (info) cartSectionId = info.sectionId;
    if (window.__skCartWatch) return;
    window.__skCartWatch = true;
    /* Event-source-agnostic: watch the cart page's own controls (theme pubsub kept as bonus path) */
    document.addEventListener('change', function (e) {
      var n = e.target && e.target.name || '';
      if (n.indexOf('updates') === 0 || n === 'quantity') scheduleCartRefresh();
    });
    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      if (e.target.closest('quantity-input button, cart-remove-button, .cart-remove-button, a[href*="/cart/change"], button[name="minus"], button[name="plus"]')) {
        scheduleCartRefresh();
      }
    });
    /* this script is deferred, so pubsub/global.js are already loaded if the theme has them */
    if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () { scheduleCartRefresh(); });
    }
  }

  window.SkyteckShipping = { estimate: estimate, money: money, initCart: initCart, liveRates: liveRates };

  function init() { initPdp(); initCart(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
